import locationsRo from './locations-ro'
import locationsFr from './locations-fr'
import locationsIt from './locations-it'
import locationsDe from './locations-de'
import locationsEs from './locations-es'

const locationsEn = [
  {
    "id": 29184,
    "city": "Palma de Mallorca",
    "address": "Palma de Mallorca Airport",
    "code": "PMI",
    "value": "PMI",
    "destination_translations": "",
    "language": "en",
    "country": "Spain"
  },
  {
    "id": 29159,
    "city": "Riga",
    "address": "Riga International Airport",
    "code": "RIX",
    "value": "RIX",
    "destination_translations": "",
    "language": "en",
    "country": "Latvia"
  },
  {
    "id": 29104,
    "city": "Timișoara",
    "address": "Timișoara Traian Vuia International Airport",
    "code": "TSR",
    "value": "TSR",
    "destination_translations": "",
    "language": "en",
    "country": "Romania"
  },
  {
    "id": 29512,
    "city": "Alghero",
    "address": "Alghero Airport",
    "code": "AHO",
    "value": "AHO",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29506,
    "city": "Amman",
    "address": "Queen Alia International Airport",
    "code": "AMM",
    "value": "AMM",
    "destination_translations": "",
    "language": "en",
    "country": "Jordan"
  },
  {
    "id": 29498,
    "city": "Amsterdam",
    "address": "Amsterdam Airport Schiphol",
    "code": "AMS",
    "value": "AMS",
    "destination_translations": "",
    "language": "en",
    "country": "Netherlands"
  },
  {
    "id": 29489,
    "city": "Ankara",
    "address": "Ankara Esenboğa Airport",
    "code": "ESB",
    "value": "ESB",
    "destination_translations": "",
    "language": "en",
    "country": "Turkey"
  },
  {
    "id": 29480,
    "city": "Antalya",
    "address": "Antalya Airport",
    "code": "AYT",
    "value": "AYT",
    "destination_translations": "",
    "language": "en",
    "country": "Turkey"
  },
  {
    "id": 29474,
    "city": "Athens",
    "address": "Athens International Airport Eleftherios Venizelos",
    "code": "ATH",
    "value": "ATH",
    "destination_translations": "",
    "language": "en",
    "country": "Greece"
  },
  {
    "id": 29466,
    "city": "Barcelona",
    "address": "Barcelona-El Prat Airport",
    "code": "BCN",
    "value": "BCN",
    "destination_translations": "",
    "language": "en",
    "country": "Spain"
  },
  {
    "id": 29460,
    "city": "Bari",
    "address": "Bari Karol Wojtyła Airport",
    "code": "BRI",
    "value": "BRI",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29451,
    "city": "Beirut",
    "address": "Beirut–Rafic Hariri International Airport",
    "code": "BEY",
    "value": "BEY",
    "destination_translations": "",
    "language": "en",
    "country": "Lebanon"
  },
  {
    "id": 29440,
    "city": "Belgrade",
    "address": "Belgrade Nikola Tesla Airport",
    "code": "BEG",
    "value": "BEG",
    "destination_translations": "",
    "language": "en",
    "country": "Serbia"
  },
  {
    "id": 29426,
    "city": "Bilbao",
    "address": "Bilbao Airport",
    "code": "BIO",
    "value": "BIO",
    "destination_translations": "",
    "language": "en",
    "country": "Spain"
  },
  {
    "id": 29417,
    "city": "Bodrum",
    "address": "Milas–Bodrum Airport",
    "code": "BJV",
    "value": "BJV",
    "destination_translations": "",
    "language": "en",
    "country": "Turkey"
  },
  {
    "id": 29409,
    "city": "Bologna",
    "address": "Bologna Guglielmo Marconi Airport",
    "code": "BLQ",
    "value": "BLQ",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29400,
    "city": "Brindisi",
    "address": "Brindisi Papola Casale Airport",
    "code": "BDS",
    "value": "BDS",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29394,
    "city": "Brussels",
    "address": "Brussels Airport",
    "code": "BRU",
    "value": "BRU",
    "destination_translations": "",
    "language": "en",
    "country": "Belgium"
  },
  {
    "id": 29375,
    "city": "Budapest",
    "address": "Budapest Ferenc Liszt International Airport",
    "code": "BUD",
    "value": "BUD",
    "destination_translations": "",
    "language": "en",
    "country": "Hungary"
  },
  {
    "id": 29366,
    "city": "Cagliari",
    "address": "Cagliari Elmas Airport",
    "code": "CAG",
    "value": "CAG",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29357,
    "city": "Cairo",
    "address": "Cairo International Airport",
    "code": "CAI",
    "value": "CAI",
    "destination_translations": "",
    "language": "en",
    "country": "Egypt"
  },
  {
    "id": 29348,
    "city": "Catania",
    "address": "Catania–Fontanarossa Airport",
    "code": "CTA",
    "value": "CTA",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  // {
  //   "id": 29342,
  //   "city": "Chișinău",
  //   "address": "Chișinău International Airport",
  //   "code": "KIV",
  //   "value": "KIV",
  //   "destination_translations": "",
  //   "language": "en",
  //   "country": "Moldova"
  // },
  {
    "id": 29334,
    "city": "Cluj-Napoca",
    "address": "Avram Iancu Cluj International Airport",
    "code": "CLJ",
    "value": "CLJ",
    "destination_translations": "",
    "language": "en",
    "country": "Romania"
  },
  {
    "id": 29320,
    "city": "Detroit",
    "address": "Detroit Metropolitan Wayne County Airport",
    "code": "DTW",
    "value": "DTW",
    "destination_translations": "",
    "language": "en",
    "country": "United States"
  },
  {
    "id": 29309,
    "city": "Frankfurt",
    "address": "Frankfurt Airport",
    "code": "FRA",
    "value": "FRA",
    "destination_translations": "",
    "language": "en",
    "country": "Germany"
  },
  {
    "id": 29300,
    "city": "Genoa",
    "address": "Genoa Cristoforo Colombo Airport",
    "code": "GOA",
    "value": "GOA",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29294,
    "city": "Gran Canaria",
    "address": "Gran Canaria Airport",
    "code": "LPA",
    "value": "LPA",
    "destination_translations": "",
    "language": "en",
    "country": "Spain"
  },
  {
    "id": 29286,
    "city": "Iași",
    "address": "Iași International Airport",
    "code": "IAS",
    "value": "IAS",
    "destination_translations": "Iași\nIaşi\nIasi\nRoumanie\nRomânia\nRomania",
    "language": "en",
    "country": "Romania"
  },
  {
    "id": 29277,
    "city": "Istanbul",
    "address": "Istanbul Airport",
    "code": "IST",
    "value": "IST",
    "destination_translations": "",
    "language": "en",
    "country": "Turkey"
  },
  {
    "id": 29271,
    "city": "İzmir",
    "address": "İzmir Adnan Menderes Airport",
    "code": "ADB",
    "value": "ADB",
    "destination_translations": "",
    "language": "en",
    "country": "Turkey"
  },
  {
    "id": 29260,
    "city": "Milan",
    "address": "Milan Linate Airport",
    "code": "LIN",
    "value": "LIN",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29255,
    "city": "Lisbon",
    "address": "Humberto Delgado Airport",
    "code": "LIS",
    "value": "LIS",
    "destination_translations": "",
    "language": "en",
    "country": "Portugal"
  },
  {
    "id": 29250,
    "city": "London",
    "address": "London Heathrow Airport",
    "code": "LHR",
    "value": "LHR",
    "destination_translations": "",
    "language": "en",
    "country": "United Kingdom"
  },
  {
    "id": 29244,
    "city": "Lyon",
    "address": "Lyon-Saint Exupéry Airport",
    "code": "LYS",
    "value": "LYS",
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 29239,
    "city": "Madrid",
    "address": "Adolfo Suárez Madrid–Barajas Airport",
    "code": "MAD",
    "value": "MAD",
    "destination_translations": "",
    "language": "en",
    "country": "Spain"
  },
  {
    "id": 29234,
    "city": "Málaga",
    "address": "Málaga-Costa del Sol Airport",
    "code": "AGP",
    "value": "AGP",
    "destination_translations": "",
    "language": "en",
    "country": "Spain"
  },
  {
    "id": 29229,
    "city": "Marseille",
    "address": "Marseille Provence Airport",
    "code": "MRS",
    "value": "MRS",
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 29224,
    "city": "Montpellier",
    "address": "Montpellier–Méditerranée Airport",
    "code": "MPL",
    "value": "MPL",
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 29209,
    "city": "Naples",
    "address": "Naples International Airport",
    "code": "NAP",
    "value": "NAP",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29199,
    "city": "Nice",
    "address": "Nice Côte d'Azur Airport",
    "code": "NCE",
    "value": "NCE",
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 29194,
    "city": "Oradea",
    "address": "Oradea International Airport",
    "code": "OMR",
    "value": "OMR",
    "destination_translations": "",
    "language": "en",
    "country": "Romania"
  },
  {
    "id": 29189,
    "city": "Palermo",
    "address": "Falcone Borsellino Airport",
    "code": "PMO",
    "value": "PMO",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29179,
    "city": "Paris",
    "address": "Charles de Gaulle Airport",
    "code": "CDG",
    "value": "CDG",
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 29174,
    "city": "Pau",
    "address": "Pau Pyrénées Airport",
    "code": "PUF",
    "value": "PUF",
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 29169,
    "city": "Prague",
    "address": "Václav Havel Airport Prague",
    "code": "PRG",
    "value": "PRG",
    "destination_translations": "",
    "language": "en",
    "country": "Czech Republic"
  },
  {
    "id": 29164,
    "city": "Riyadh",
    "address": "King Khalid International Airport",
    "code": "RUH",
    "value": "RUH",
    "destination_translations": "",
    "language": "en",
    "country": "Saudi Arabia"
  },
  {
    "id": 29154,
    "city": "Rome",
    "address": "Leonardo da Vinci–Fiumicino Airport",
    "code": "FCO",
    "value": "FCO",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29149,
    "city": "Thessaloniki",
    "address": "Thessaloniki Airport Makedonia",
    "code": "SKG",
    "value": "SKG",
    "destination_translations": "",
    "language": "en",
    "country": "Greece"
  },
  {
    "id": 29139,
    "city": "Sofia",
    "address": "Sofia International Airport",
    "code": "SOF",
    "value": "SOF",
    "destination_translations": "",
    "language": "en",
    "country": "Bulgaria"
  },
  {
    "id": 29134,
    "city": "Strasbourg",
    "address": "Strasbourg Airport",
    "code": "SXB",
    "value": "SXB",
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 29129,
    "city": "Suceava",
    "address": "Ștefan cel Mare International Airport",
    "code": "SCV",
    "value": "SCV",
    "destination_translations": "",
    "language": "en",
    "country": "Romania"
  },
  {
    "id": 29124,
    "city": "Tallinn",
    "address": "Tallinn Lennart Meri Airport",
    "code": "TLL",
    "value": "TLL",
    "destination_translations": "",
    "language": "en",
    "country": "Estonia"
  },
  {
    "id": 32947,
    "city": "Tirana",
    "address": "Tirana International Airport Mother Teresa",
    "code": "TIA",
    "value": "TIA",
    "destination_translations": "Tirana\nTiranë\nRinas\nAlbania\nShqipëri",
    "language": "en",
    "country": "Albania"
  },
  {
    "id": 29119,
    "city": "Tampere",
    "address": "Tampere–Pirkkala Airport",
    "code": "TMP",
    "value": "TMP",
    "destination_translations": "",
    "language": "en",
    "country": "Finland"
  },
  {
    "id": 29114,
    "city": "Tel Aviv",
    "address": "Ben Gurion International Airport",
    "code": "TLV",
    "value": "TLV",
    "destination_translations": "",
    "language": "en",
    "country": "Israel"
  },
  {
    "id": 29109,
    "city": "Tenerife",
    "address": "Tenerife North Airport",
    "code": "TFN",
    "value": "TFN",
    "destination_translations": "",
    "language": "en",
    "country": "Spain"
  },
  {
    "id": 29099,
    "city": "Turin",
    "address": "Turin International Airport",
    "code": "TRN",
    "value": "TRN",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29094,
    "city": "Toulouse",
    "address": "Toulouse–Blagnac Airport",
    "code": "TLS",
    "value": "TLS",
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 29084,
    "city": "Venice",
    "address": "Venice Marco Polo Airport",
    "code": "VCE",
    "value": "VCE",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 29079,
    "city": "Vienna",
    "address": "Vienna International Airport",
    "code": "VIE",
    "value": "VIE",
    "destination_translations": "",
    "language": "en",
    "country": "Austria"
  },
  {
    "id": 29074,
    "city": "Vilnius",
    "address": "Vilnius International Airport",
    "code": "VNO",
    "value": "VNO",
    "destination_translations": "",
    "language": "en",
    "country": "Lithuania"
  },
  {
    "id": 29031,
    "city": "Washington",
    "address": "Washington Dulles International Airport",
    "code": "IAD",
    "value": "IAD",
    "destination_translations": "",
    "language": "en",
    "country": "United States"
  },
  {
    "id": 29066,
    "city": "Baia Mare",
    "address": "Maramureș International Airport",
    "code": "BAY",
    "value": "BAY",
    "destination_translations": "",
    "language": "en",
    "country": "Romania"
  },
  {
    "id": 7953,
    "city": "Bucharest",
    "address": "Henri Coandă International Airport",
    "code": "OTP",
    "value": "OTP",
    "destination_translations": "București\nBucuresti\nBucharest\nBucarest\nBukarest\nHenri Coanda\nHenri Coandă\nRoumanie\nRomânia\nRomania",
    "language": "en",
    "country": "Romania"
  },
  {
    "id": 34302,
    "city": "A Coruña",
    "address": "A Coruña Airport",
    "code": "LCG",
    "value": "LCG",
    "destination_translations": "La Coruna\nLa Coruña\nA Coruña\nA Coruña Airport\nA Coruña Airport",
    "language": "en",
    "country": "Spain"
  },
  {
    "id": 34307,
    "city": "New York",
    "address": "John F. Kennedy International Airport",
    "code": "JFK",
    "value": "JFK",
    "destination_translations": "",
    "language": "en",
    "country": "United States"
  },
  {
    "id": 44862,
    "city": "Dublin",
    "address": "Dublin Airport",
    "code": "DUB",
    "value": "DUB",
    "destination_translations": "",
    "language": "en",
    "country": "Ireland"
  },
  {
    "id": 44870,
    "city": "Copenhagen",
    "address": "Copenhagen Airport",
    "code": "CPH",
    "value": "CPH",
    "destination_translations": "",
    "language": "en",
    "country": "Denmark"
  },
  {
    "id": 44877,
    "city": "Gothenburg",
    "address": "Göteborg Landvetter Airport",
    "code": "GOT",
    "value": "GOT",
    "destination_translations": "",
    "language": "en",
    "country": "Sweden"
  },
  {
    "id": 44884,
    "city": "Stockholm",
    "address": "Stockholm Arlanda Airport",
    "code": "ARN",
    "value": "ARN",
    "destination_translations": "",
    "language": "en",
    "country": "Sweden"
  },
  {
    "id": 45583,
    "city": "Florence",
    "address": "Amerigo Vespucci Airport",
    "code": "FLR",
    "value": "FLR",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 45594,
    "city": "Reggio Calabria",
    "address": "Reggio Calabria Airport",
    "code": "REG",
    "value": "REG",
    "destination_translations": "",
    "language": "en",
    "country": "Italy"
  },
  {
    "id": 45600,
    "city": "Porto",
    "address": "Francisco Sá Carneiro Airport",
    "code": "OPO",
    "value": "OPO",
    "destination_translations": "",
    "language": "en",
    "country": "Portugal"
  },
  {
    "id": 45606,
    "city": "Paris",
    "address": "Paris Orly Airport",
    "code": "ORY",
    "value": "ORY", 
    "destination_translations": "",
    "language": "en",
    "country": "France"
  },
  {
    "id": 45607,
    "city": "Chisinau",
    "address": "Chisinau International Airport",
    "code": "RMO",
    "value": "RMO",
    "destination_translations": "",
    "language": "en",
    "country": "Moldova"
  },
  {
    "id": 46001,
    "city": "Calgary",
    "address": "Calgary International Airport",
    "code": "YYC",
    "value": "YYC",
    "destination_translations": "Calgary\nCalgary Airport\nCanada",
    "language": "en",
    "country": "Canada"
  },
  {
    "id": 46002,
    "city": "Toronto",
    "address": "Toronto Pearson International Airport",
    "code": "YYZ",
    "value": "YYZ",
    "destination_translations": "Toronto\nToronto Pearson\nPearson\nCanada",
    "language": "en",
    "country": "Canada"
  },
  {
    "id": 46003,
    "city": "Vancouver",
    "address": "Vancouver International Airport",
    "code": "YVR",
    "value": "YVR",
    "destination_translations": "Vancouver\nVancouver Airport\nCanada",
    "language": "en",
    "country": "Canada"
  },
  {
    "id": 46004,
    "city": "Boston",
    "address": "Logan International Airport",
    "code": "BOS",
    "value": "BOS",
    "destination_translations": "Boston\nLogan\nBoston Airport\nUnited States\nUSA",
    "language": "en",
    "country": "United States"
  },
  {
    "id": 46005,
    "city": "Las Vegas",
    "address": "Harry Reid International Airport",
    "code": "LAS",
    "value": "LAS",
    "destination_translations": "Las Vegas\nHarry Reid\nMcCarran\nUnited States\nUSA",
    "language": "en",
    "country": "United States"
  },
  {
    "id": 46006,
    "city": "Los Angeles",
    "address": "Los Angeles International Airport",
    "code": "LAX",
    "value": "LAX",
    "destination_translations": "Los Angeles\nLAX\nUnited States\nUSA",
    "language": "en",
    "country": "United States"
  },
  {
    "id": 46007,
    "city": "Seattle",
    "address": "Seattle-Tacoma International Airport",
    "code": "SEA",
    "value": "SEA",
    "destination_translations": "Seattle\nSeattle-Tacoma\nSeaTac\nUnited States\nUSA",
    "language": "en",
    "country": "United States"
  },
  {
    "id": 46008,
    "city": "San Francisco",
    "address": "San Francisco International Airport",
    "code": "SFO",
    "value": "SFO",
    "destination_translations": "San Francisco\nSFO\nUnited States\nUSA",
    "language": "en",
    "country": "United States"
  },
  {
    "id": 46009,
    "city": "Anchorage",
    "address": "Ted Stevens Anchorage International Airport",
    "code": "ANC",
    "value": "ANC",
    "destination_translations": "Anchorage\nTed Stevens\nAlaska\nUnited States\nUSA",
    "language": "en",
    "country": "United States"
  }
];

// Language-specific location data
const locationData = {
  en: locationsEn,
  ro: locationsRo,
  fr: locationsFr,
  it: locationsIt,
  de: locationsDe,
  es: locationsEs
};  

export function getLocationsByLanguage(language: string = 'en') {
  return locationData[language as keyof typeof locationData] || locationData.en;
}

export default locationsEn;